import { render, staticRenderFns } from "./SpaceCard.vue?vue&type=template&id=35b38e18&scoped=true"
import script from "./SpaceCard.vue?vue&type=script&lang=ts"
export * from "./SpaceCard.vue?vue&type=script&lang=ts"
import style0 from "./SpaceCard.vue?vue&type=style&index=0&id=35b38e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b38e18",
  null
  
)

export default component.exports